/* eslint-disable quotes */
/**
 *  axios 
 *  
 */
import axios from 'axios';
import error from './error';
import store from '../../store';
import router from '../../router';
import reConnect from './reconnect';
import { get } from 'lodash';
import { Message as ElMessage } from "element-ui";


// 是否使用服务器代理，根据开关请求不同的api服务
const baseURL = process.env.VUE_APP_USE_PROXY == '1' ? process.env.BASE_URL : process.env.VUE_APP_API_URL;
const SERVICE_ERROR = '40';
const USER_NOT_FOUND_ERROR = '524';
const WORKSPACEK_NOT_AUTH_ERROR = '522';
const UNAUTHORIZED = '401';

axios.defaults.baseURL = baseURL;

// 异常情况处理
const dealStatusCode = async (res) => {
    let message = '';
    const code = get(res, 'data.code', '')
    if (typeof res === 'undefined') {
        router.push("/401")
        return Promise.reject();
    }

    if (res.status == '200' && res.data.code != '0') {
        // 自定义错误，则提示为后端定义的message 
        message = res.data.msg;

        if (code == SERVICE_ERROR) {
            try {
                const proxyMessage = JSON.parse(message);
                message = proxyMessage.message || message;
            } catch (e) {
                console.log(e)
            }
        } else if (code == USER_NOT_FOUND_ERROR) {
            const data = res.data.data;
            const redirect = process.env.BASE_URL + 'oauth_redirect?cb=' + data.redirect;
            const params = new URLSearchParams({
                auth_by: data.auth_by,
                client_id: data.client_id,
                redirect_uri: encodeURI(redirect),
                response_type: data.response_type,
                scope: data.scope,
                state: data.state,
            });
            //先跳去home登录页选择是手机登录还是oauth登录
            const redirect_url = data.oauth_url + '?' + params.toString();
            console.log('redirect_url:' + redirect_url);
            window.location.href = redirect_url;
            return;
        } else if (code == WORKSPACEK_NOT_AUTH_ERROR) {
            //如果当前公司未触发授权，跳转到选公司页面
            window.location.href = process.env.VUE_APP_TAPD_BASE_PATH + 'company/choose_company';
            return;
        } else if (code == UNAUTHORIZED) {
            //如果当前公司未触发授权，跳转到选公司页面
            window.location.href = process.env.BASE_URL + '#/';
            return;
        }

        if (!res.config.hasOwnProperty('showError') || res.config.showError) {
            ElMessage.error({
                message: message,
                duration: 0, // 不自动关闭
                customClass: 'tips-ctl'
              });
        }

        return Promise.reject(res.data);
    } else if (res.status == '401') {
        try {
            let tmp = await reConnect(res);

            return tmp;
        } catch (e) {
            if (e) {
                ElMessage.error({ message: e, customClass: 'tips-ctl' });
            }
            return Promise.reject();
        }
    } else if (res.status == '403') {
        router.push("/401")

        return Promise.reject();
    }
    try {
        message = error[`${res.status}`]
    } catch (e) {
        message = error['1000']
    }

    ElMessage.error({ message: message, customClass: 'tips-ctl' });
    return Promise.reject(res.data);
}

// 请求拦截器
axios.interceptors.request.use(async function (config) {
    //内网不传TAPD-BK-AUTH
    if (process.env.VUE_APP_IS_CLOUD == 1) {
        config.headers['X-COMPANY-ID'] = store.state.companyId;
        if ('api/meeting/object' == config.url || 'api/meeting/user/login/meeting_webview' == config.url || 'api/meeting/js_ticket' == config.url) {
            config.headers['TAPD-BK-AUTH'] = store.getters.statApiToken;
        } else if ('api/meeting/user/login/meeting_webview_tapd_login' == config.url) {
            config.headers['TAPD-BK-AUTH'] = "";
        } else {
            config.headers['TAPD-BK-AUTH'] = store.getters.apiToken;
        }
    }
    config.headers['X-WORKSPACE-ID'] = store.state.workspaceId;
    config.headers['X-LANGUAGE'] = store.state.lang

    // 给所有请求默认加上 withCredentials: true 这样来透传taihu鉴权
    config.withCredentials = true;
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use(async function (res) {
    console.log('response:', JSON.stringify(res));
    if (res.data.code == '0') {
        // 正常状态请求
        return res.data.data;
    } else {
        return await dealStatusCode(res);
    }
}, async function (err) {
    return await dealStatusCode(err.response);
});

export default axios